// Stat tile + row used on both dashboards. CSS lives in AdminLayout.css.

import React from 'react';

export default function StatCard({ label, value, hint }) {
  return (
    <div className="portal-stat">
      <div className="portal-stat-label">{label}</div>
      <div className="portal-stat-value">{value}</div>
      {hint && <div className="portal-stat-hint">{hint}</div>}
    </div>
  );
}

export function StatRow({ children }) {
  return <div className="portal-stat-row">{children}</div>;
}
